import * as React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';

function AutomationsOnce({ color = colors.actionMinor[500], ...props }) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
            <path
                fill={color}
                d="M14 10h6l-1.675 2.009a6 6 0 0 0-6.16 7.392L10 22H8l1-7H4l9-13h2l-1 8Z"
            />
            <path
                fill={color}
                d="M18 14a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm-.889 1.777v.89H18v3.556h.889v-4.446H17.11Z"
            />
        </svg>
    );
}

export default AutomationsOnce;
